import { gql } from 'graphql-tag'

export const BREAKOUT_SESSION_JOIN_BANNER_SESSION_REGISTRATION = gql`
    fragment BreakoutSessionJoinBannerSessionRegistration on session_registration {
        id
        session_breakout_id
    }

`
